var canvas, canvas2, text, newText, zoom, cWidth = 2000, cHeight = 1400,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data, sizeCrop,
    scale_factor, newheight, leftOb, imageUrl,
    placeholderimg1, placeholderimg2, placeholderimg3,
    placeholderimg4,placeholderimg5,img,
    leftMarker, rightMarker, vLine;

var loader = jQuery('#customLoader'),
    cropper = "", canvas, boxWidth, boxLeft, boxTop,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;

var outLine,sizeBmW = 715, sizeBmH = 450,
    sizeB0W = 216, sizeB0H = 216,
    sizeB1W = 293, sizeB1H = 293,
    sizeB2W = 334, sizeB2H = 100,
    sizeB3W = 1830, sizeB3H = 1176;

imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');


let backImg = document.querySelector("#background_birthday");
let bg_img = new fabric.Image(backImg, {
  left: 0,   
  top: 0,
  scaleX: 1.95,
  scaleY: 1.95,
  selectable: false
});

let frameImg = document.querySelector("#design_birthday");
let simpleImage = new fabric.Image(frameImg, {
  left: 0,   
  top: 0,
  scaleX: 1.945,
  scaleY: 1.945,
  selectable: false
});
window['canvas2'] = new fabric.Canvas('canvas2', {
  width: cWidth,
  height: cHeight
});


window['canvas2'].add(bg_img);
bg_img.sendToBack();

// MARK this object as background so we can find it later
bg_img.isBackground = true;
window.bgImage = bg_img;


window['canvas2'].add(simpleImage);
simpleImage.bringToFront();
addModify(window['canvas2']);


let starsImg = document.querySelector("#lamp_border");

let lampBorder;

// Load the image once and show it by default
fabric.Image.fromURL(starsImg.src, function(img) {
  lampBorder = img;
  lampBorder.set({
    left: halfWidth,
    top: 1195,
    scaleX: 0.4,
    scaleY: 0.4,
    selectable: false
  });

  // Add to canvas2 by default
  window['canvas2'].add(lampBorder);
  lampBorder.bringToFront();
  window['canvas2'].renderAll();

  // Handle select dropdown changes
  document.getElementById('lamp-border-select').addEventListener('change', function() {
    if (this.value === 'Yes') {
      if (!window['canvas2'].getObjects().includes(lampBorder)) {
        window['canvas2'].add(lampBorder);
        lampBorder.bringToFront();
      }
    } else {
      window['canvas2'].remove(lampBorder);
    }
    window['canvas2'].renderAll();
  });

}, { crossOrigin: 'anonymous' });

// Optional: apply any canvas modifications
addModify(window['canvas2']);



function applyPlaceholder10Watermark(img) {
  img.set({
    opacity: 0.15
  });
}



window['placeholderimg1'] = new fabric.Rect({
  left: 618,
  top: 232,
  width: sizeB0W,
  height: sizeB0H,
  fill: 'rgba(0,0,0,0.1)'
});

window['placeholderimg2'] = new fabric.Rect({
  left: 366,
  top: 630,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)'
});

window['placeholderimg3'] = new fabric.Rect({
  left: 780,
  top: 630,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)'
});

window['placeholderimg4'] = new fabric.Rect({
  left: 1201,
  top: 630,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)'
});

window['placeholderimg5'] = new fabric.Rect({
  left: 1621,
  top: 630,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)'
});

window['placeholderimg6'] = new fabric.Rect({
  left: 370,
  top: 867,
  width: sizeB2W,
  height: sizeB2H,
  fill: 'rgba(0,0,0,0.1)'
});

window['placeholderimg7'] = new fabric.Rect({
  left: 779,
  top: 867,
  width: sizeB2W,
  height: sizeB2H,
  fill: 'rgba(0,0,0,0.1)'
});

window['placeholderimg8'] = new fabric.Rect({
  left: 1207,
  top: 867,
  width: sizeB2W,
  height: sizeB2H,
  fill: 'rgba(0,0,0,0.1)'
});

window['placeholderimg9'] = new fabric.Rect({
  left: 1628,
  top: 867,
  width: sizeB2W,
  height: sizeB2H,
  fill: 'rgba(0,0,0,0.1)'
});

window['placeholderimg10'] = new fabric.Rect({
  left: 1000,
  top: 658,
  width: sizeB3W,
  height: sizeB3H,
  fill: 'rgba(0,0,0,0)'
});

window['canvas2'].add(window['placeholderimg1'], window['placeholderimg2'], window['placeholderimg3'], window['placeholderimg4'], window['placeholderimg5'],window['placeholderimg6'], window['placeholderimg7'], window['placeholderimg8'], window['placeholderimg9'], window['placeholderimg10']);
window['canvas2'].sendToBack(window['placeholderimg1']);
window['canvas2'].sendToBack(window['placeholderimg2']);
window['canvas2'].sendToBack(window['placeholderimg3']);
window['canvas2'].sendToBack(window['placeholderimg4']);
window['canvas2'].sendToBack(window['placeholderimg5']);
window['canvas2'].sendToBack(window['placeholderimg6']);
window['canvas2'].sendToBack(window['placeholderimg7']);
window['canvas2'].sendToBack(window['placeholderimg8']);
window['canvas2'].sendToBack(window['placeholderimg9']);
window['canvas2'].sendToBack(window['placeholderimg10']);

// ===============================
// DUMMY IMAGE PLACEHOLDERS (from <img> tags)
// ===============================
const dummy1El = document.querySelector("#dummy1");
const dummy2El = document.querySelector("#dummy2");
const dummy3El = document.querySelector("#dummy3");
const dummy4El = document.querySelector("#dummy4");
const dummy5El = document.querySelector("#dummy5");
const dummy6El = document.querySelector("#dummy6");
const dummy7El = document.querySelector("#dummy7");
const dummy8El = document.querySelector("#dummy8");
const dummy9El = document.querySelector("#dummy9");


if (dummy1El) {
  let dummyImg1 = new fabric.Image(dummy1El, {
    left: window['placeholderimg1'].left,
    top: window['placeholderimg1'].top,
    selectable: false,
    originX: 'left',
    originY: 'top'
  });

  // scale to fit
  const scale1X = window['placeholderimg1'].width / dummyImg1.width;
  const scale1Y = window['placeholderimg1'].height / dummyImg1.height;
  dummyImg1.scale(Math.min(scale1X, scale1Y));

  window['dummyimg1'] = dummyImg1;
  window['canvas2'].add(dummyImg1);
}

if (dummy2El) {
  let dummyImg2 = new fabric.Image(dummy2El, {
    left: window['placeholderimg2'].left,
    top: window['placeholderimg2'].top,
    selectable: false,
    originX: 'left',
    originY: 'top'
  });

  const scale2X = window['placeholderimg2'].width / dummyImg2.width;
  const scale2Y = window['placeholderimg2'].height / dummyImg2.height;
  dummyImg2.scale(Math.min(scale2X, scale2Y));

  window['dummyimg2'] = dummyImg2;
  window['canvas2'].add(dummyImg2);
}

if (dummy3El) {
  let dummyImg3 = new fabric.Image(dummy3El, {
    left: window['placeholderimg3'].left,
    top: window['placeholderimg3'].top,
    selectable: false,
    originX: 'left',
    originY: 'top'
  });

  const scale2X = window['placeholderimg3'].width / dummyImg3.width;
  const scale2Y = window['placeholderimg3'].height / dummyImg3.height;
  dummyImg3.scale(Math.min(scale2X, scale2Y));

  window['dummyimg3'] = dummyImg3;
  window['canvas2'].add(dummyImg3);
}

if (dummy4El) {
  let dummyImg4 = new fabric.Image(dummy4El, {
    left: window['placeholderimg4'].left,
    top: window['placeholderimg4'].top,
    selectable: false,
    originX: 'left',
    originY: 'top'
  });

  const scale2X = window['placeholderimg4'].width / dummyImg4.width;
  const scale2Y = window['placeholderimg4'].height / dummyImg4.height;
  dummyImg4.scale(Math.min(scale2X, scale2Y));

  window['dummyimg4'] = dummyImg4;
  window['canvas2'].add(dummyImg4);
}

if (dummy5El) {
  let dummyImg5 = new fabric.Image(dummy5El, {
    left: window['placeholderimg5'].left,
    top: window['placeholderimg5'].top,
    selectable: false,
    originX: 'left',
    originY: 'top'
  });

  const scale2X = window['placeholderimg5'].width / dummyImg5.width;
  const scale2Y = window['placeholderimg5'].height / dummyImg5.height;
  dummyImg5.scale(Math.min(scale2X, scale2Y));

  window['dummyimg5'] = dummyImg5;
  window['canvas2'].add(dummyImg5);
}

if (dummy6El) {
  let dummyImg6 = new fabric.Image(dummy6El, {
    left: window['placeholderimg6'].left,
    top: window['placeholderimg6'].top,
    selectable: false,
    originX: 'left',
    originY: 'top'
  });

  const scale2X = window['placeholderimg6'].width / dummyImg6.width;
  const scale2Y = window['placeholderimg6'].height / dummyImg6.height;
  dummyImg6.scale(Math.min(scale2X, scale2Y));

  window['dummyimg6'] = dummyImg6;
  window['canvas2'].add(dummyImg6);
}

if (dummy7El) {
  let dummyImg7 = new fabric.Image(dummy7El, {
    left: window['placeholderimg7'].left,
    top: window['placeholderimg7'].top,
    selectable: false,
    originX: 'left',
    originY: 'top'
  });

  const scale2X = window['placeholderimg7'].width / dummyImg7.width;
  const scale2Y = window['placeholderimg7'].height / dummyImg7.height;
  dummyImg7.scale(Math.min(scale2X, scale2Y));

  window['dummyimg7'] = dummyImg7;
  window['canvas2'].add(dummyImg7);
}

if (dummy8El) {
  let dummyImg8 = new fabric.Image(dummy8El, {
    left: window['placeholderimg8'].left,
    top: window['placeholderimg8'].top,
    selectable: false,
    originX: 'left',
    originY: 'top'
  });

  const scale2X = window['placeholderimg8'].width / dummyImg8.width;
  const scale2Y = window['placeholderimg8'].height / dummyImg8.height;
  dummyImg8.scale(Math.min(scale2X, scale2Y));

  window['dummyimg8'] = dummyImg8;
  window['canvas2'].add(dummyImg8);
}

if (dummy9El) {
  let dummyImg9 = new fabric.Image(dummy9El, {
    left: window['placeholderimg9'].left,
    top: window['placeholderimg9'].top,
    selectable: false,
    originX: 'left',
    originY: 'top'
  });

  const scale2X = window['placeholderimg9'].width / dummyImg9.width;
  const scale2Y = window['placeholderimg9'].height / dummyImg9.height;
  dummyImg9.scale(Math.min(scale2X, scale2Y));

  window['dummyimg9'] = dummyImg9;
  window['canvas2'].add(dummyImg9);
}

window['canvas2'].renderAll();

// Assign object keys for upload control
window.uploadStore = window.uploadStore || { first: null, second: null, third: null, four: null, five: null, six: null, seven: null, eight: null, nine: null, ten: null };
window['placeholderimg1'].objKey = 'first';
window['placeholderimg2'].objKey = 'second';
window['placeholderimg3'].objKey = 'third';
window['placeholderimg4'].objKey = 'four';
window['placeholderimg5'].objKey = 'five';
window['placeholderimg6'].objKey = 'six';
window['placeholderimg7'].objKey = 'seven';
window['placeholderimg8'].objKey = 'eight';
window['placeholderimg9'].objKey = 'nine';
window['placeholderimg10'].objKey = 'ten';




function prepareUploadForInput(inputId, placeholderName) {
  const input = document.getElementById(inputId);
  if (!input) return;

  input.addEventListener('change', function (e) {
    window.currentPlaceholderForCrop = window[placeholderName];
    window.reCroper = jQuery(this).parent().next().find('.btnReCrop');
    window.available_height = (window.currentPlaceholderForCrop && window.currentPlaceholderForCrop.height) || null;

    // ✅ Assign proper crop ratio
    switch (placeholderName) {
      case "placeholderimg1":
        window.sizeCrop = 1;
        break;
      case "placeholderimg2":
        window.sizeCrop = 1;
        break;
      case "placeholderimg3":
        window.sizeCrop = 1; 
        break;
      case "placeholderimg4":
        window.sizeCrop = 1;
        break;
      case "placeholderimg5":
        window.sizeCrop = 1; 
        break;
      case "placeholderimg6":
        window.sizeCrop = 3.34; 
        break;
      case "placeholderimg7":
        window.sizeCrop = 3.34; 
        break;
      case "placeholderimg8":
        window.sizeCrop = 3.34; 
        break;
      case "placeholderimg9":
        window.sizeCrop = 3.34; 
        break;
      case "placeholderimg10":
        window.sizeCrop = 1.56; 
        break;
    }

    readURL2(e.target);
  });
}


prepareUploadForInput('image_upload_first',  'placeholderimg1');
prepareUploadForInput('image_upload_second', 'placeholderimg2');
prepareUploadForInput('image_upload_third', 'placeholderimg3');
prepareUploadForInput('image_upload_four', 'placeholderimg4');
prepareUploadForInput('image_upload_five', 'placeholderimg5');
prepareUploadForInput('image_upload_six', 'placeholderimg6');
prepareUploadForInput('image_upload_seven', 'placeholderimg7');
prepareUploadForInput('image_upload_eight', 'placeholderimg8');
prepareUploadForInput('image_upload_nine', 'placeholderimg9');
prepareUploadForInput('image_upload_ten', 'placeholderimg10');



function placeObjectAboveBackground(obj) {
  const canvas = window['canvas2'];
  if (!canvas || !obj) return;

  // find bg - prefer window.bgImage if present
  const bg = window.bgImage || canvas.getObjects().find(o => o.isBackground);

  if (!bg) {
    // if no bg found, send object to back (safe fallback)
    canvas.sendToBack(obj);
    canvas.renderAll();
    return;
  }

  // determine target index = bgIndex + 1
  const objs = canvas.getObjects();
  const bgIndex = objs.indexOf(bg);
  const targetIndex = Math.min(bgIndex + 1, objs.length - 1);

  // move object to that index
  try {
    canvas.moveTo(obj, targetIndex);
  } catch (e) {
    // fallback: send to back then bring forward once
    canvas.sendToBack(obj);
    canvas.bringForward(obj);
  }
  canvas.renderAll();
}




window.logos1 = { obj: null }; // for first section
window.logos2 = { obj: null }; // for second section
window.logos3 = { obj: null }; // for third section
window.logos4 = { obj: null }; // for forth section


$(document).ready(function () {
  const canvas = window['canvas2'];

  const logoMap = {
    "Google": "google_logo",
    "Facebook": "facebook_logo",
    "Instagram": "instagram_logo",
    "TikTok": "tiktok_logo",
    "WhatsApp": "whatsapp_logo",
    "YouTube": "youtube_logo",
    "Easypaisa": "easypaisa_logo",
    "JazzCash": "jazzcash_logo",
    "SadaPay": "sadapay_logo"
  };

  // Generic addLogo function with slot number
  function addLogo(group, logoId, left, top) {
    const imgEl = document.getElementById(logoId);
    if (!imgEl) return;

    fabric.Image.fromURL(imgEl.src, function (img) {
      if (group.obj) canvas.remove(group.obj);

      img.set({
        left,
        top,
        scaleX: 0.4,
        scaleY: 0.4,
        selectable: false
      });

      canvas.add(img);
      group.obj = img;
      canvas.renderAll();
    }, { crossOrigin: 'anonymous' });
  }

  // Default positions for each slot
  var positions = {
    1: { left: 350, top: 860 },
    2: { left: 778, top: 860 },
    3: { left: 1195, top: 860 },
    4: { left: 1625, top: 860 }
  };


  // init select 1
  function initSelect(selector, group, pos) {
    const defaultOption = $(selector).val();
    addLogo(group, logoMap[defaultOption], pos.left, pos.top);

    $(selector).on("change", function () {
      const selected = $(this).val();
      addLogo(group, logoMap[selected], pos.left, pos.top);
    });
  }

  initSelect(".social_account_logo", window.logos1, positions[1]);
  initSelect(".social_account_logo_2", window.logos2, positions[2]);
  initSelect(".social_account_logo_3", window.logos3, positions[3]);
  initSelect(".social_account_logo_4", window.logos4, positions[4]);
});


window['text1Page'] = new fabric.Text('check', {
  left: 1140,
  top: 230,
  fontSize: 130,
  fontFamily: 'Dancing Script',
  fill: 'black',
  fontWeight: 'bold',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false,
  selectable: false,
  originX: 'left',
  textAlign: 'left'
});

var fontName = window['text1Page'].fontFamily;
jQuery('.choose_font').val("'" + fontName + "'").trigger('change');

window['canvas2'].add(window['text1Page']);

document.getElementById('text_1').addEventListener('focus', function () {
  if (window['text1Page'].text === 'A taste of home') {
    window['text1Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});

function fitTextToWidth(textObj, maxWidth) {
  let fontSize = 130; 
  textObj.set({ fontSize });

  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_1').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text1Page'].set({
    text: newText,
    left: 780,
    originX: 'left',  
    textAlign: 'left' 
  });
  fitTextToWidth(window['text1Page'], 1050);
  window['text1Page'].bringToFront();
  window['canvas2'].renderAll();
});



window['text2Page'] = new fabric.Text('Review us',{
  left: 365,
  top: 415,
  fontSize: 50,
  fontFamily: 'Arial',
  fontWeight: 'bold',
  fill: 'black',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});


window['canvas2'].add(window['text2Page']);

document.getElementById('text_2').addEventListener('focus', function () {
  if (window['text2Page'].text === 'Review us') {
    window['text2Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});

function fitTextToWidth2(textObj, maxWidth) {
  let fontSize = 50; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}
document.getElementById('text_2').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text2Page'].set('text', newText);
  fitTextToWidth2(window['text2Page'], 400);
  window['text2Page'].bringToFront();
  window['canvas2'].renderAll();
});



window['text3Page'] = new fabric.Text('Follow Us',{
  left: 780,
  top: 415,
  fontSize: 50,
  fontFamily: 'Arial',
  fontWeight: 'bold',
  fill: 'black',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});


window['canvas2'].add(window['text3Page']);

document.getElementById('text_3').addEventListener('focus', function () {
  if (window['text3Page'].text === 'Follow Us') {
    window['text3Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});

function fitTextToWidth3(textObj, maxWidth) {
  let fontSize = 50; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}
document.getElementById('text_3').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text3Page'].set('text', newText);
  fitTextToWidth3(window['text3Page'], 400);
  window['text3Page'].bringToFront();
  window['canvas2'].renderAll();
});


window['text4Page'] = new fabric.Text('Follow us',{
  left: 1200,
  top: 415,
  fontSize: 50,
  fontFamily: 'Arial',
  fontWeight: 'bold',
  fill: 'black',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});


window['canvas2'].add(window['text4Page']);

document.getElementById('text_4').addEventListener('focus', function () {
  if (window['text4Page'].text === 'Follow us') {
    window['text4Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});

function fitTextToWidth4(textObj, maxWidth) {
  let fontSize = 50; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}
document.getElementById('text_4').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text4Page'].set('text', newText);
  fitTextToWidth4(window['text4Page'], 400);
  window['text4Page'].bringToFront();
  window['canvas2'].renderAll();
});



window['text5Page'] = new fabric.Text('Contact us',{
  left: 1625,
  top: 415,
  fontSize: 50,
  fontFamily: 'Arial',
  fontWeight: 'bold',
  fill: 'black',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});


window['canvas2'].add(window['text5Page']);

document.getElementById('text_5').addEventListener('focus', function () {
  if (window['text5Page'].text === 'Contact us') {
    window['text5Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});

function fitTextToWidth5(textObj, maxWidth) {
  let fontSize = 50; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}
document.getElementById('text_5').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text5Page'].set('text', newText);
  fitTextToWidth5(window['text5Page'], 400);
  window['text5Page'].bringToFront();
  window['canvas2'].renderAll();
});



window['text6Page'] = new fabric.Text('Tap or Scan to connect with us', {
  left: 1070,
  top: 995,
  fontSize: 55,
  fontFamily: 'Times New Roman',
  fill: 'black',
  fontWeight: 'bold',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false,
  selectable: false,
  originX: 'left',
  textAlign: 'left'
});

var fontName = window['text6Page'].fontFamily;
jQuery('.choose_font2').val("'" + fontName + "'").trigger('change');

window['canvas2'].add(window['text6Page']);

document.getElementById('text_6').addEventListener('focus', function () {
  if (window['text6Page'].text === 'Connect with us') {
    window['text6Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});

function fitTextToWidth6(textObj, maxWidth) {
  let fontSize = 55; 
  textObj.set({ fontSize });

  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_6').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text6Page'].set({
    text: newText,
    left: 715,
    originX: 'left',  
    textAlign: 'left' 
  });
  fitTextToWidth6(window['text6Page'], 950);
  window['text6Page'].bringToFront();
  window['canvas2'].renderAll();
});


var maxWidth = 1050;
var maxHeight = 100;

var para = "YOUR REVIEWS ARE GREATLY APPRECIATED\nWE HOPE YOU ENJOYED YOUR VISIT" ;

window['text7Page'] = new fabric.Text(para,{
  left: 1000,
  top: 1110,
  width: 1050,
  fontSize: 32,
  fontWeight: 'bold',
  fontFamily: 'Arial',
  textAlign: 'center',
  isWrapping: true,
  fill: 'black'
});


window['canvas2'].add(window['text7Page']);


var minFontSize = 10;
var maxFontSize = 35;

// Clear text on input focus if default
document.getElementById('text_7').addEventListener('focus', function () {
  if (window['text7Page'].text === 'YOUR REVIEWS ARE GREATLY APPRECIATED\nWE HOPE YOU ENJOYED YOUR VISIT') {
    window['text7Page'].set('text', '');
    window['text7Page'].bringToFront();
    window['canvas2'].renderAll();
  }
});


// Helper: Adjust font size to fit both width and height
function autoFitText2(textbox, maxW, maxH) {
  let fontSize = maxFontSize;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_7').addEventListener('input', function (e) {
  const input = e.target.value;
  window['text7Page'].set({
    text: input
  });
  fitTextToBox(window['text7Page'], maxWidth, maxHeight);
});

function fitTextToBox(textObj, maxWidth, maxHeight) {
  let fontSize = maxFontSize;

  textObj.set({ fontSize });

  // Helper function to get height (fabric.Text uses height property)
  function isTooBig() {
    return textObj.width > maxWidth || textObj.height > maxHeight;
  }

  // blackuce font size until both width and height fit within limits
  while (isTooBig() && fontSize > minFontSize) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}


var maxWidth2 = 330;
var maxHeight2 = 100;

var para = "www.website.com" ;

window['text8Page'] = new fabric.Text(para,{
  left: 370,
  top: 867,
  width: 330,
  fontSize: 38,
  fontWeight: 'bold',
  fontFamily: 'Arial',
  textAlign: 'center',
  isWrapping: true,
  fill: 'black'
});


window['canvas2'].add(window['text8Page']);


var minFontSize2 = 10;
var maxFontSize2 = 45;

// Clear text on input focus if default
document.getElementById('text_8').addEventListener('focus', function () {
  if (window['text8Page'].text === 'www.website.com') {
    window['text8Page'].set('text', '');
    window['text8Page'].bringToFront();
    window['canvas2'].renderAll();
  }
});


// Helper: Adjust font size to fit both width and height
function autoFitText2(textbox, maxW, maxH) {
  let fontSize = maxFontSize2;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize2
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_8').addEventListener('input', function (e) {
  const input = e.target.value;
  window['text8Page'].set({
    text: input
  });
  fitTextToBox(window['text8Page'], maxWidth2, maxHeight2);
});

function fitTextToBox(textObj, maxWidth2, maxHeight2) {
  let fontSize = maxFontSize2;

  textObj.set({ fontSize });

  // Helper function to get height (fabric.Text uses height property)
  function isTooBig() {
    return textObj.width > maxWidth2 || textObj.height > maxHeight2;
  }

  // Reduce font size until both width and height fit within limits
  while (isTooBig() && fontSize > minFontSize2) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}




var maxWidth3 = 330;
var maxHeight3 = 100;

var para = "www.website.com" ;

window['text9Page'] = new fabric.Text(para,{
  left: 779,
  top: 867,
  width: 330,
  fontSize: 38,
  fontWeight: 'bold',
  fontFamily: 'Arial',
  textAlign: 'center',
  isWrapping: true,
  fill: 'black'
});


window['canvas2'].add(window['text9Page']);


var minFontSize3 = 10;
var maxFontSize3 = 45;

// Clear text on input focus if default
document.getElementById('text_9').addEventListener('focus', function () {
  if (window['text9Page'].text === 'www.website.com') {
    window['text9Page'].set('text', '');
    window['text9Page'].bringToFront();
    window['canvas2'].renderAll();
  }
});


// Helper: Adjust font size to fit both width and height
function autoFitText2(textbox, maxW, maxH) {
  let fontSize = maxFontSize3;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize3
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_9').addEventListener('input', function (e) {
  const input = e.target.value;
  window['text9Page'].set({
    text: input
  });
  fitTextToBox(window['text9Page'], maxWidth3, maxHeight3);
});

function fitTextToBox(textObj, maxWidth3, maxHeight3) {
  let fontSize = maxFontSize2;

  textObj.set({ fontSize });

  // Helper function to get height (fabric.Text uses height property)
  function isTooBig() {
    return textObj.width > maxWidth3 || textObj.height > maxHeight3;
  }

  // Reduce font size until both width and height fit within limits
  while (isTooBig() && fontSize > minFontSize3) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}


var maxWidth4 = 330;
var maxHeight4 = 100;

var para = "www.website.com" ;

window['text10Page'] = new fabric.Text(para,{
  left: 1207,
  top: 867,
  width: 330,
  fontSize: 38,
  fontWeight: 'bold',
  fontFamily: 'Arial',
  textAlign: 'center',
  isWrapping: true,
  fill: 'black'
});


window['canvas2'].add(window['text10Page']);


var minFontSize4 = 10;
var maxFontSize4 = 45;

// Clear text on input focus if default
document.getElementById('text_10').addEventListener('focus', function () {
  if (window['text10Page'].text === 'www.website.com') {
    window['text10Page'].set('text', '');
    window['text10Page'].bringToFront();
    window['canvas2'].renderAll();
  }
});


// Helper: Adjust font size to fit both width and height
function autoFitText2(textbox, maxW, maxH) {
  let fontSize = maxFontSize4;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize4
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_10').addEventListener('input', function (e) {
  const input = e.target.value;
  window['text10Page'].set({
    text: input
  });
  fitTextToBox(window['text10Page'], maxWidth4, maxHeight4);
});

function fitTextToBox(textObj, maxWidth4, maxHeight4) {
  let fontSize = maxFontSize2;

  textObj.set({ fontSize });

  // Helper function to get height (fabric.Text uses height property)
  function isTooBig() {
    return textObj.width > maxWidth4 || textObj.height > maxHeight4;
  }

  // Reduce font size until both width and height fit within limits
  while (isTooBig() && fontSize > minFontSize4) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}


var maxWidth5 = 330;
var maxHeight5 = 100;

var para = "www.website.com" ;

window['text11Page'] = new fabric.Text(para,{
  left: 1628,
  top: 867,
  width: 330,
  fontSize: 38,
  fontWeight: 'bold',
  fontFamily: 'Arial',
  textAlign: 'center',
  isWrapping: true,
  fill: 'black'
});


window['canvas2'].add(window['text11Page']);


var minFontSize5 = 10;
var maxFontSize5 = 45;

// Clear text on input focus if default
document.getElementById('text_11').addEventListener('focus', function () {
  if (window['text11Page'].text === 'www.website.com') {
    window['text11Page'].set('text', '');
    window['text11Page'].bringToFront();
    window['canvas2'].renderAll();
  }
});


// Helper: Adjust font size to fit both width and height
function autoFitText2(textbox, maxW, maxH) {
  let fontSize = maxFontSize5;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize5
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_11').addEventListener('input', function (e) {
  const input = e.target.value;
  window['text11Page'].set({
    text: input
  });
  fitTextToBox(window['text11Page'], maxWidth5, maxHeight5);
});

function fitTextToBox(textObj, maxWidth5, maxHeight5) {
  let fontSize = maxFontSize2;

  textObj.set({ fontSize });

  // Helper function to get height (fabric.Text uses height property)
  function isTooBig() {
    return textObj.width > maxWidth5 || textObj.height > maxHeight5;
  }

  // Reduce font size until both width and height fit within limits
  while (isTooBig() && fontSize > minFontSize5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}


// ===============================
// CONTROL CANVAS VISIBILITY BASED ON SELECTION
// ===============================
jQuery(document).ready(function ($) {
  const selectMain = $('select[name="properties[Select Social Logo / Upload Image / Enter Text]"]');
  const canvas = window['canvas2'];

  function updateCanvasDisplay(value) {
    // Hide first logo only
    if (window.logos1 && window.logos1.obj) window.logos1.obj.set({ visible: false });

    // Hide other elements
    if (window['placeholderimg6']) window['placeholderimg6'].set({ visible: false });
    if (window['dummyimg6']) window['dummyimg6'].set({ visible: false });
    if (window['uploadStore']?.six) window['uploadStore'].six.set({ visible: false });
    if (window['text8Page']) window['text8Page'].set({ visible: false });

    if (value === 'Social Logos' && window.logos1?.obj) {
      window.logos1.obj.set({ visible: true });
    } else if (value === 'Upload Image') {
      window['uploadStore']?.six?.set({ visible: true }) ||
      window['dummyimg6']?.set({ visible: true }) ||
      window['placeholderimg6']?.set({ visible: true });
    } else if (value === 'Enter Text' && window['text8Page']) {
      window['text8Page'].set({ visible: true });
    }

    canvas.renderAll();
  }

  selectMain.on('change', function () {
    updateCanvasDisplay($(this).val());
  });
  updateCanvasDisplay(selectMain.val());
});



jQuery(document).ready(function ($) {
  const selectMain = $('select[name="properties[Select Social Logo / Upload Image / Enter Text 2]"]');
  const canvas = window['canvas2'];

  function updateCanvasDisplay(value) {
    // Hide second logo only
    if (window.logos2 && window.logos2.obj) window.logos2.obj.set({ visible: false });

    // Hide other elements
    if (window['placeholderimg7']) window['placeholderimg7'].set({ visible: false });
    if (window['dummyimg7']) window['dummyimg7'].set({ visible: false });
    if (window['uploadStore']?.seven) window['uploadStore'].seven.set({ visible: false });
    if (window['text9Page']) window['text9Page'].set({ visible: false });

    if (value === 'Social Logos' && window.logos2?.obj) {
      window.logos2.obj.set({ visible: true });
    } else if (value === 'Upload Image') {
      window['uploadStore']?.seven?.set({ visible: true }) ||
      window['dummyimg7']?.set({ visible: true }) ||
      window['placeholderimg7']?.set({ visible: true });
    } else if (value === 'Enter Text' && window['text9Page']) {
      window['text9Page'].set({ visible: true });
    }

    canvas.renderAll();
  }

  selectMain.on('change', function () {
    updateCanvasDisplay($(this).val());
  });
  updateCanvasDisplay(selectMain.val());
});


jQuery(document).ready(function ($) {
  const selectMain = $('select[name="properties[Select Social Logo / Upload Image / Enter Text 3]"]');
  const canvas = window['canvas2'];

  function updateCanvasDisplay(value) {
    // Hide second logo only
    if (window.logos3 && window.logos3.obj) window.logos3.obj.set({ visible: false });

    // Hide other elements
    if (window['placeholderimg8']) window['placeholderimg8'].set({ visible: false });
    if (window['dummyimg8']) window['dummyimg8'].set({ visible: false });
    if (window['uploadStore']?.eight) window['uploadStore'].eight.set({ visible: false });
    if (window['text10Page']) window['text10Page'].set({ visible: false });

    if (value === 'Social Logos' && window.logos3?.obj) {
      window.logos3.obj.set({ visible: true });
    } else if (value === 'Upload Image') {
      window['uploadStore']?.eight?.set({ visible: true }) ||
      window['dummyimg8']?.set({ visible: true }) ||
      window['placeholderimg8']?.set({ visible: true });
    } else if (value === 'Enter Text' && window['text10Page']) {
      window['text10Page'].set({ visible: true });
    }

    canvas.renderAll();
  }

  selectMain.on('change', function () {
    updateCanvasDisplay($(this).val());
  });
  updateCanvasDisplay(selectMain.val());
});


jQuery(document).ready(function ($) {
  const selectMain = $('select[name="properties[Select Social Logo / Upload Image / Enter Text 4]"]');
  const canvas = window['canvas2'];

  function updateCanvasDisplay(value) {
    // Hide second logo only
    if (window.logos4 && window.logos4.obj) window.logos4.obj.set({ visible: false });

    // Hide other elements
    if (window['placeholderimg9']) window['placeholderimg9'].set({ visible: false });
    if (window['dummyimg9']) window['dummyimg9'].set({ visible: false });
    if (window['uploadStore']?.nine) window['uploadStore'].nine.set({ visible: false });
    if (window['text11Page']) window['text11Page'].set({ visible: false });

    if (value === 'Social Logos' && window.logos4?.obj) {
      window.logos4.obj.set({ visible: true });
    } else if (value === 'Upload Image') {
      window['uploadStore']?.nine?.set({ visible: true }) ||
      window['dummyimg9']?.set({ visible: true }) ||
      window['placeholderimg9']?.set({ visible: true });
    } else if (value === 'Enter Text' && window['text11Page']) {
      window['text11Page'].set({ visible: true });
    }

    canvas.renderAll();
  }

  selectMain.on('change', function () {
    updateCanvasDisplay($(this).val());
  });
  updateCanvasDisplay(selectMain.val());
});





function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleablack', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

  jQuery(window).on('load',function(){
    canvasBlock(canvas);
  });

  jQuery(window).on('resize',function(){
    canvasBlock(canvas);
  });
}

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler(eventData,transform){
  var target = transform.target;
  activeOb = canvas.getActiveObject();
  canvas.remove(activeOb);
  canvas.renderAll();
}

initCropper();

function readURL2(input){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  try { if (cropper) cropper.destroy(); } catch(e){}

  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      jQuery('#blah').attr('src', e.target.result);
      // write to the exact reCrop button we saved earlier
      if (window.reCroper && window.reCroper.length) {
        window.reCroper.attr('data-img', e.target.result);
      }
    };
    reader.readAsDataURL(input.files[0]);
    setTimeout(initCropper, 800);
  } else {
    loader.addClass('hidden');
  }
}


function removeOldPlaceholderImage(canvas, placeholder) {

  const key = placeholder.objKey;

  // 1. remove from store
  if (window.uploadStore && window.uploadStore[key]) {
    try {
      canvas.remove(window.uploadStore[key]);
    } catch(e) {}
    window.uploadStore[key] = null;
  }

  // 2. SAFETY: remove ANY image sitting on same placeholder position
  const objs = canvas.getObjects();

  objs.forEach(obj => {
    if (obj.type === 'image') {

      const leftMatch = Math.abs(obj.left - placeholder.left) < 2;
      const topMatch  = Math.abs(obj.top - placeholder.top) < 2;

      if (leftMatch && topMatch) {
        canvas.remove(obj);
      }
    }
  });

  canvas.renderAll();
}


function addImageFromDataUrl(dataUrl, placeholder) {
  var canvas = window['canvas2'];
  fabric.Image.fromURL(dataUrl, function(fabricImg) {
    // remove existing for this placeholder
    removeOldPlaceholderImage(canvas, placeholder);

    if (placeholder === window['placeholderimg1'] && window['dummyimg1']) {
      window['dummyimg1'].set({ visible: false });
    }
    if (placeholder === window['placeholderimg2'] && window['dummyimg2']) {
      window['dummyimg2'].set({ visible: false });
    }
    if (placeholder === window['placeholderimg3'] && window['dummyimg3']) {
      window['dummyimg3'].set({ visible: false });
    }
    if (placeholder === window['placeholderimg4'] && window['dummyimg4']) {
    window['dummyimg4'].set({ visible: false });
    }
    if (placeholder === window['placeholderimg5'] && window['dummyimg5']) {
      window['dummyimg5'].set({ visible: false });
    }
    if (placeholder === window['placeholderimg6'] && window['dummyimg6']) {
      window['dummyimg6'].set({ visible: false });
    }
    if (placeholder === window['placeholderimg7'] && window['dummyimg7']) {
      window['dummyimg7'].set({ visible: false });
    }
    if (placeholder === window['placeholderimg8'] && window['dummyimg8']) {
    window['dummyimg8'].set({ visible: false });
    }
    if (placeholder === window['placeholderimg9'] && window['dummyimg9']) {
      window['dummyimg9'].set({ visible: false });
    }

    // Fit proportionally into placeholder
    const ph = getPlaceholderSize(placeholder);
    const scaleX = ph.w / fabricImg.width;
    const scaleY = ph.h / fabricImg.height;
    const scale = Math.min(scaleX, scaleY);

    fabricImg.set({
      left: placeholder.left,
      top: placeholder.top,
      originX: 'left',
      originY: 'top',
      selectable: true,
      scaleX: scale,
      scaleY: scale
    });

    // save base props for deterministic resize later
    fabricImg.__baseProps = { left: fabricImg.left, top: fabricImg.top, scaleX: fabricImg.scaleX, scaleY: fabricImg.scaleY };

    canvas.add(fabricImg);
    canvas.renderAll();

    // store
    window.uploadStore[placeholder.objKey] = fabricImg;

    // hide placeholder rect
    placeholder.set({ visible: false });
    canvas.renderAll();

    // NEW: if this was placeholder6, keep this image just above background
    if (placeholder === window['placeholderimg10']) {

      // WATERMARK EFFECT
      applyPlaceholder4Watermark(fabricImg);

      placeObjectAboveBackground(fabricImg);
    }
  }, { crossOrigin: 'anonymous' });
}



function addCroppedImgForPlaceholder(placeholder, imgurl) {
  if (!placeholder || !placeholder.objKey) {
    console.error('Invalid placeholder passed to addCroppedImgForPlaceholder');
    return;
  }
  const key = placeholder.objKey;        // 'first' | 'second' | ...
  const canvas = window['canvas2'];

  // remove any existing uploaded image for this placeholder
  removeOldPlaceholderImage(canvas, placeholder);

  if (placeholder === window['placeholderimg1'] && window['dummyimg1']) {
    window['dummyimg1'].set({ visible: false });
  }
  if (placeholder === window['placeholderimg2'] && window['dummyimg2']) {
    window['dummyimg2'].set({ visible: false });
  }
  if (placeholder === window['placeholderimg3'] && window['dummyimg3']) {
    window['dummyimg3'].set({ visible: false });
  }
  if (placeholder === window['placeholderimg4'] && window['dummyimg4']) {
    window['dummyimg4'].set({ visible: false });
  }
  if (placeholder === window['placeholderimg5'] && window['dummyimg5']) {
    window['dummyimg5'].set({ visible: false });
  }
  if (placeholder === window['placeholderimg6'] && window['dummyimg6']) {
      window['dummyimg6'].set({ visible: false });
    }
  if (placeholder === window['placeholderimg7'] && window['dummyimg7']) {
    window['dummyimg7'].set({ visible: false });
  }
  if (placeholder === window['placeholderimg8'] && window['dummyimg8']) {
    window['dummyimg8'].set({ visible: false });
  }
  if (placeholder === window['placeholderimg9'] && window['dummyimg9']) {
    window['dummyimg9'].set({ visible: false });
  }

  fabric.Image.fromURL(imgurl, function(newImg) {
    // compute placeholder visible size
    const phW = (placeholder.width || 0) * (placeholder.scaleX || 1);
    const phH = (placeholder.height || 0) * (placeholder.scaleY || 1);

    // scale proportionally to fit placeholder
    const scaleX = phW / newImg.width || 1;
    const scaleY = phH / newImg.height || 1;
    const scale = Math.min(scaleX, scaleY);

    newImg.set({
      left:  placeholder.left,
      top:   placeholder.top,
      originX: 'left',
      originY: 'top',
      selectable: true,
      scaleX: scale,
      scaleY: scale
    });

    // WATERMARK ONLY FOR PLACEHOLDER 4
    if (placeholder === window['placeholderimg10']) {

      applyPlaceholder10Watermark(newImg);

      placeObjectAboveBackground(newImg);
    }

    // record base props for resize function
    newImg.__baseProps = { left: newImg.left, top: newImg.top, scale: newImg.scaleX };

    canvas.add(newImg);
    window.uploadStore[key] = newImg;

    // ensure placeholder hidden
    placeholder.set({ visible: false });

    // NEW: ensure placeholder6 image sits above background but behind all other elements
    if (placeholder === window['placeholderimg10']) {
      placeObjectAboveBackground(newImg);
    }

    canvas.renderAll();


    // hide the placeholder rect (optional)
    try { placeholder.set({ visible: false }); } catch(e){}
    canvas.renderAll();
  }, { crossOrigin: 'anonymous' });
}

function initCropper() {
  var image = document.getElementById('blah');
  cropper = new Cropper(image, {
    viewMode: 1,
    dragMode: 'move',
    aspectRatio: window.sizeCrop || 1, // ✅ use global ratio
    restore: false,
    guides: false,
    center: true,
    highlight: true,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: false,
    data: {}
  });
  jQuery('.popupImg').show();
  jQuery('#tadaWidget').addClass('hidden');
  loader.addClass('hidden');
}

document.getElementById('crop_button').addEventListener('click', function(){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');

  var imgurl = cropper.getCroppedCanvas().toDataURL();

  // MUST use the placeholder we saved earlier
  var placeholder = window.currentPlaceholderForCrop || window['placeholderimg1'];
  if (!placeholder) {
    console.warn('No placeholder selected for cropping. Using placeholderimg1 as fallback.');
    placeholder = window['placeholderimg1'];
  }

  // call function that replaces the image ONLY for that placeholder
  addCroppedImgForPlaceholder(placeholder, imgurl);

  setTimeout(function(){
    if (window.reCroper && window.reCroper.length) {
      window.reCroper.parent && window.reCroper.parent().removeClass('hidden');
    }
    jQuery('.popupImg').hide();
    loader.addClass('hidden');
    jQuery('#tadaWidget').removeClass('hidden');
  }, 400);
});

document.getElementById('zoom_out').addEventListener('click', function(){
  cropper.zoom(-0.1);
});

document.getElementById('zoom_in').addEventListener('click', function(){
  cropper.zoom(0.1);
});

document.getElementById('reset_button').addEventListener('click', function(){
  cropper.reset();
});

document.getElementById('cancelCropper').addEventListener('click', function(){
  jQuery('.popupImg').hide();
  jQuery('#tadaWidget').removeClass('hidden');
});


jQuery(document).on('click', '.btnReCrop', function () {
  loader.removeClass('hidden');

  const $btn = jQuery(this);
  const imgurl = $btn.attr('data-img');
  const dataObjName = $btn.attr('data-obj');
  const dataCanvasName = $btn.attr('data-canvas');
  const dataHeight = $btn.attr('data-height');
  const ratio = $btn.attr('data-ratio');

  // ✅ Determine correct crop ratio
  if (ratio) {
    window.sizeCrop = parseFloat(ratio);
  } else {
    switch (placeholderName) {
      case "placeholderimg1":
        window.sizeCrop = 1;
        break;
      case "placeholderimg2":
        window.sizeCrop = 1;
        break;
      case "placeholderimg3":
        window.sizeCrop = 1; 
        break;
      case "placeholderimg4":
        window.sizeCrop = 1;
        break;
      case "placeholderimg5":
        window.sizeCrop = 1; 
        break;
      case "placeholderimg6":
        window.sizeCrop = 3.34; 
        break;
      case "placeholderimg7":
        window.sizeCrop = 3.34; 
        break;
      case "placeholderimg8":
        window.sizeCrop = 3.34; 
        break;
      case "placeholderimg9":
        window.sizeCrop = 3.34; 
        break;
      case "placeholderimg10":
        window.sizeCrop = 1.56; 
        break;
    }
  }

  // Set current placeholder and canvas
  if (dataObjName && window[dataObjName]) {
    window.currentPlaceholderForCrop = window[dataObjName];
  }

  window.reCroper = $btn;
  window.canvas = window[dataCanvasName] || window['canvas2'];
  window.available_height = dataHeight;

  // Show image in cropper popup
  jQuery('#blah').attr('src', imgurl);
  try { cropper && cropper.destroy(); } catch (e) { }
  initCropper();
  jQuery('.popupImg').show();
  loader.addClass('hidden');
});


jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});


jQuery(document).on('change', '.fontFamily', function () {
  var fontID = jQuery(this).attr('data-canvas'),
      textOb = jQuery(this).attr('data-obj');
  canvas = window[fontID];
  activeOb = window[textOb];

  activeOb.set({
    fontFamily: this.value,
    left: 780,
    originX: 'left',
    textAlign: 'left'
  });
  fontFamily = jQuery(this).val();
  canvas.renderAll();
  updateFont(window['text1Page'], fontFamily);
  fitTextToWidth(window['text1Page'], 1050);
  canvas.renderAll();
});


jQuery(document).on('change', '.fontFamily2', function () {
  var fontID = jQuery(this).attr('data-canvas'),
      textOb = jQuery(this).attr('data-obj');
  canvas = window[fontID];
  activeOb = window[textOb];

  activeOb.set({
    fontFamily: this.value,
    left: 715,
    originX: 'left',
    textAlign: 'left'
  });
  fontFamily = jQuery(this).val();
  canvas.renderAll();
  fitTextToWidth6(window['text6Page'], 950);
  canvas.renderAll();
});


function updateFont(activeOb,family){
  if(activeOb){
    if(family == ''){
      family = activeOb.fontFamily;
    }
    sCAle = activeOb.scaleX;
    activeOb.set('fontFamily',family);
    activeOb.scaleX = .5;
    activeOb.setCoords();
    canvas.renderAll();
    activeOb.scaleX = sCAle;
    activeOb.setCoords();
    canvas.renderAll();
  }
}

function loadColorPicker(colorBox){
  jQuery('#'+colorBox).colorpicker({
    inline: true,
    container: true,
    extensions:[{
      name: 'swatches',
      options:{
        colors:{
          'tetrad1': 'transparent',
          'tetrad2': '#e30405',
          'tetrad3': '#197b30',
          'tetrad4': '#0054a5',
          'tetrad5': '#ffcc00',
          'tetrad6': '#f6ebbe',
          'tetrad7': '#ffea00',
          'tetrad8': '#f8931d',
          'tetrad9': '#f499c2',
          'tetrad10': '#959595',
          'tetrad11': '#fef335',
          'tetrad12': '#a0400d',
          'tetrad13': '#000000',
          'tetrad14': '#604973',
          'tetrad15': '#afe8fc',
          'tetrad16': '#fffafa',
          'tetrad17': '#bc8cbe',
          'tetrad18': '#ff69b4',
          'tetrad19': '#93278f',
          'tetrad20': '#009987',
          'tetrad21': '#0af447',
          'tetrad22': '#00008b',
          'tetrad23': '#006400'
        },
        namesAsValues: false
      }
    }],
    template: '<div class="colorpicker">' +
      '<div class="colorpicker-saturation"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-hue"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-alpha">' +
      '   <div class="colorpicker-alpha-color"></div>' +
      '   <i class="colorpicker-guide"></i>' +
      '</div>' +
      '<div class="colorpicker-bar">' +
      '   <a href="javascript:void(0);" class="button btn-block colorOFF">Ok</a>'+
      '   <div class="ctn-icon-eyedropper dropper-eyedrop"><svg class="icon icon-eyedropper" viewBox="0 0 16 16">'+
      '   <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5'+
      '   0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207'+
      '   1.207 0 0 0 0-1.708zM2 12.707l7-7L10.293 7l-7 7H2z"/></svg></div>'+
      '</div>' +
      '</div>'
  }).on('colorpickerCreate', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('id'),
        active = colorBox.find('.currentColor'),
        activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
    },200);
  }).on('colorpickerChange', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('data-canvas'),
          textOb = colorBox.attr('data-obj'),
          active = colorBox.find('.currentColor'),
          activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
      colorBox.attr('data-color',activeCOLOR);
      canvas = window[colorID];
      activeOb = window[textOb];
      sCAle = activeOb.scaleX;
      activeOb.set('fill',activeCOLOR);
      activeOb.scaleX = .5;
      activeOb.setCoords();
      canvas.renderAll();
      activeOb.scaleX = sCAle;
      activeOb.setCoords();
      canvas.renderAll();
    },200);
  });
  jQuery(document).on('click','.colorBox',function(){
    jQuery('.colorBox').each(function(){
      jQuery(this).next().hide();
    });
    jQuery(this).next().show();
  });
  jQuery(document).on('click','.colorOFF',function(){
    var parENt = jQuery(this).parent().parent(),
        toolBarBox = parENt.parent().parent().parent().attr('id');
    if(toolBarBox === 'labelBase'){
      parENt.parent().parent().parent().parent().removeClass('active');
    }else{
      parENt.hide();
    }
  });
}

jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});


jQuery(window).on('load',function(){
  canvasBlock(canvas2);
  window['text1Page'].set('text','A taste of home');
  window['canvas2'].renderAll();
  // loadFirstImg();
});


function getCookie(name){
  let nameEQ = name + "=";
  let cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++){
    let cookie = cookies[i].trim();
    if(cookie.indexOf(nameEQ) === 0){
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

window.addEventListener("load", function(){
  if(getCookie("firstVisit")){
    console.log("✅ Cookie exists:", getCookie("firstVisit"));
  } else{
    console.log("❌ Cookie does not exist!");
    document.cookie = "firstVisit=textresizing; expires=" + new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString() + "; path=/;";
    location.reload();
  }
});


async function handleUpload(fileInputs,timeID){
  const temp_images = [];
  
  for (let input of fileInputs){
    const file = input.files[0]; // Only first file per input
    const croppedURL = jQuery(input).attr('data-cropped');
    if(croppedURL != ''){
      temp_images.push(croppedURL);
    }
    if(file){
      const base64 = await toBase64(file); // ✅ now safely inside async
      temp_images.push(base64);
    }
  }
  if(temp_images.length === 0){
    alert("Please select at least one image.");
    return;
  }
  const payload = {
    timeId: timeID,
    temp_images: temp_images
  };
  console.log(payload);
  try {
    const response = await fetch('//technology-architects.com/tasweer-modules/upload_client_img.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    
    const result = await response.json();
    console.log("Upload result:", result);
    var int = 1, wall = 1, upCrop;
    result.uploaded_images.forEach(img => {
      if(jQuery('#image'+int).length < 1){
        if (int % 2 === 0) {
          upCrop = 'User Uploaded ';
        }else{
          upCrop = 'Cropped ';
        }
        jQuery('#preview').append('<input type="hidden" id="image'+int+'" name="properties['+ upCrop + wall+']">');
        if(upCrop == 'User Uploaded '){
          wall += 1;
        }
      }
      if (img.status === "success") {
        jQuery('#image'+int).val(img.image_url);
        int += 1;
      } else {
        console.warn("Upload failed:", img.error);
      }
    });
    jQuery('.product-form__buttons .product-form__submit').trigger('click');
    loader.addClass('hidden');
  } catch (error) {
    console.error("Upload error:", error);
    alert("Upload failed.");
  }
}

// ✅ Convert a file to base64 string
function toBase64(file){
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}


/* fetch Call */
var size,thumbnail;
var loadedObject,companyName,chooseFont,text1,socialUplaodText,socialLogo1,qrCodeText,text2,socialUplaodText2,socialLogo2,qrCodeText2,text3,
socialUplaodText3,socialLogo3,qrCodeText3,text4,socialUplaodText4,socialLogo4,qrCodeText4,scanText,chooseFont2,enterText,borderLamp,additionalInfo,wMark,svgMrk;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    resizeObjects(window['canvas2']);
    const id = ['canvas2'];
    const canvas = window['canvas2'];
    size = 350;
    loadMark(id,canvas,size);
    size = 4000;
    removeMark(canvas,size);
    // hideExtras(canvas);
    canvas.remove(bg_img);
    window['canvas2'] = canvas.toDataURL('image/png');
    companyName = jQuery('.company_name input').val();
    chooseFont = jQuery('.choose_font option:selected').val();
    text1 = jQuery('.text_1 input').val();
    socialUplaodText = jQuery('.social_uplaod_text option:selected').val();
    let select1 = $('select[name="properties[Select Social Logo / Upload Image / Enter Text]"]').val();
    let socialLogo1 = '';
    let qrCodeText = '';
    if (select1 === 'Social Logos') {
      socialLogo1 = jQuery('.social_account_logo option:selected').val();
    } else if (select1 === 'Enter Text') {
      qrCodeText = jQuery('.qr_code_text textarea').val();
    }
    text2 = jQuery('.text_2 input').val();
    socialUplaodText2 = jQuery('.social_uplaod_text_2 option:selected').val();
    let select2 = $('select[name="properties[Select Social Logo / Upload Image / Enter Text 2]"]').val();
    let socialLogo2 = '';
    let qrCodeText2 = '';
    if (select2 === 'Social Logos') {
      socialLogo2 = jQuery('.social_account_logo_2 option:selected').val();
    } else if (select2 === 'Enter Text') {
      qrCodeText2 = jQuery('.qr_code_text_2 textarea').val();
    } 
    text3 = jQuery('.text_3 input').val();
    socialUplaodText3 = jQuery('.social_uplaod_text_3 option:selected').val();
    let select3 = $('select[name="properties[Select Social Logo / Upload Image / Enter Text 3]"]').val();
    let socialLogo3 = '';
    let qrCodeText3 = '';
    if (select3 === 'Social Logos') {
      socialLogo3 = jQuery('.social_account_logo_3 option:selected').val();
    } else if (select3 === 'Enter Text') {
      qrCodeText3 = jQuery('.qr_code_text_3 textarea').val();
    }  
    text4 = jQuery('.text_4 input').val();
    socialUplaodText4 = jQuery('.social_uplaod_text_4 option:selected').val();
    let select4 = $('select[name="properties[Select Social Logo / Upload Image / Enter Text 4]"]').val();
    let socialLogo4 = '';
    let qrCodeText4 = '';
    if (select4 === 'Social Logos') {
      socialLogo4 = jQuery('.social_account_logo_4 option:selected').val();
    } else if (select4 === 'Enter Text') {
      qrCodeText4 = jQuery('.qr_code_text_4 textarea').val();
    }  
    scanText = jQuery('.scan_text input').val();
    chooseFont2 = jQuery('.choose_font2 option:selected').val();
    enterText = jQuery('.enter_text textarea').val();
    borderLamp = jQuery('.border_Lamp option:selected').val();
    additionalInfo = jQuery('.tShirtImg textarea').val();
    // showExtras(canvas);
    canvasBlock(canvas);
    console.log(window['canvas2']);
    fetch('//technology-architects.com/tasweer-modules/save_order.php',{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:  JSON.stringify({
        temp_image: window['canvas2t'],
        original_image: window['canvas2']
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      var previewId = data[0],
          extraImg1 = data[1];
      jQuery('#previewImg').val(previewId);
      jQuery('#preExtraImg').val(extraImg1);
      jQuery('#companyName').val(companyName);
      jQuery('#chooseFont').val(chooseFont);
      jQuery('#text1').val(text1);
      jQuery('#socialUplaodText').val(socialUplaodText);
      jQuery('#socialLogo1').val(socialLogo1);
      jQuery('#qrCodeText').val(qrCodeText);
      jQuery('#text2').val(text2);
      jQuery('#socialUplaodText2').val(socialUplaodText2);
      jQuery('#socialLogo2').val(socialLogo2);
      jQuery('#qrCodeText2').val(qrCodeText2);
      jQuery('#text3').val(text3);
      jQuery('#socialUplaodText3').val(socialUplaodText3);
      jQuery('#socialLogo3').val(socialLogo3);
      jQuery('#qrCodeText3').val(qrCodeText3);
      jQuery('#text4').val(text4);
      jQuery('#socialUplaodText4').val(socialUplaodText4);
      jQuery('#socialLogo4').val(socialLogo4);
      jQuery('#qrCodeText4').val(qrCodeText4);
      jQuery('#scanText').val(scanText);
      jQuery('#chooseFont2').val(chooseFont2);
      jQuery('#enterText').val(enterText);
      jQuery('#borderLamp').val(borderLamp);
      jQuery('#addInfo').val(additionalInfo);
      //console.log('Server response:', data);
      const fileInputs = document.querySelectorAll('.upload_image input[type="file"]');
      handleUpload(fileInputs,previewId);
    })
    .catch(error => console.error('Error uploading images:', error));
  },100);
});



function resizeObjects(canvas) {
  let objectsToGroup = [];

  // Add text fields if exist
  for (let i = 1; i <= 11; i++) {
    if (window[`text${i}Page`]) {
      window[`text${i}Page`].setCoords();
      objectsToGroup.push(window[`text${i}Page`]);
    }
  }

  // Add simpleImage if exists
  if (typeof simpleImage !== 'undefined' && simpleImage) {
    simpleImage.setCoords();
    objectsToGroup.push(simpleImage);
  }

  // Add Star Image if exists
  if (typeof lampBorder !== 'undefined' && lampBorder) {
    lampBorder.setCoords();
    objectsToGroup.push(lampBorder);
  }

  // ✅ Add uploaded images (multiple)
  if (window.uploadStore) {
    Object.keys(window.uploadStore).forEach(key => {
      let obj = window.uploadStore[key];
      if (obj) {
        obj.setCoords();
        objectsToGroup.push(obj);
      }
    });
  } else {
    // fallback: single `img` (your old one)
    if (typeof img !== 'undefined' && img) {
      img.setCoords();
      objectsToGroup.push(img);
    }
  }

  // Add placeholder images
  for (let i = 1; i <= 10; i++) {
    if (typeof window[`placeholderimg${i}`] !== 'undefined' && window[`placeholderimg${i}`]) {
      window[`placeholderimg${i}`].setCoords();
      objectsToGroup.push(window[`placeholderimg${i}`]);
    }
  }

  // ✅ Add dummy placeholder images (Google, YouTube, etc.)
  for (let i = 1; i <= 10; i++) {
    if (window[`dummyimg${i}`]) {
      window[`dummyimg${i}`].setCoords();
      objectsToGroup.push(window[`dummyimg${i}`]);
    }
  }

  // ✅ Add new social logos (logos1, logos2) if exist
  if (window.logos1 && window.logos1.obj) {
    window.logos1.obj.setCoords();
    objectsToGroup.push(window.logos1.obj);
  }
  if (window.logos2 && window.logos2.obj) {
    window.logos2.obj.setCoords();
    objectsToGroup.push(window.logos2.obj);
  }
  if (window.logos3 && window.logos3.obj) {
    window.logos3.obj.setCoords();
    objectsToGroup.push(window.logos3.obj);
  }
  if (window.logos4 && window.logos4.obj) {
    window.logos4.obj.setCoords();
    objectsToGroup.push(window.logos4.obj);
  }

  if (objectsToGroup.length === 0) return;

  // Group all objects and resize
  var designResiz = new fabric.Group(objectsToGroup, {
    left: 995,
    top: 750,
    originX: 'center',
    originY: 'center'
  });

  designResiz.scaleToWidth(2050);
  designResiz.setCoords();

  canvas.renderAll();
}




function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.remove(bg_img);
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}

function removeMark(canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}